import {
    convertCurrencyFormatPositiveNegative,
    RaikoBaseCardContainer, RaikoCustomTable,
    RaikoGridOneColumn,
    RaikoSectionContainer, RaikoTableTitleContainer,
    showErrorMessage
} from "@moeindal/base-raiko-panel-components";
import {SettingService} from "../../serverService/settingService/SettingService";
import {LoadingHelper} from "../../util/LoadingHelper";
import {useLoadingDispatcher} from "../../context/LoadingContext";
import React, {useEffect, useState} from "react";
import {detectServerErrorMessage} from "../../util/detectServerErrorMessage";
import {Skeleton} from "@mui/material";
import {css} from "@emotion/css";
import SettingLoanTypeTableHeader from "./SettingLoanTypeTableHeader";

export default function SettingLoanTypes() {

    const service = new SettingService()

    const loading = new LoadingHelper(useLoadingDispatcher())
    const [loadingShimmerState, setLoadingShimmerState] = useState(false)

    const [loanKindTables, setLoanKindTables] = useState([]);

    const [openDialog, setOpenDialog] = useState(false);
    const handleOpenDialog = () => setOpenDialog(true)
    const handleCloseDialog = () => setOpenDialog(false)

    useEffect(() => {
        getDataFromServer()
    }, []);

    function getDataFromServer() {
        setLoadingShimmerState(true)
        service.getLoanKindTable()
            .then(response => {

                setLoanKindTables([])
                response.map((item, index) => {
                    setLoanKindTables(prev => [
                        ...prev,
                        {
                            title: `${convertCurrencyFormatPositiveNegative(item.minBalance)} - ${convertCurrencyFormatPositiveNegative(item.maxBalance)}`,
                            header: generateTableHeader(item.headers),
                            items: generateTableItems(item.rows)
                        }
                    ])
                })
            }).catch(reason => {
            showErrorMessage(detectServerErrorMessage(reason))
        }).finally(_ => {
            setLoadingShimmerState(false)
        })
    }

    function generateTableHeader(headers) {
        const _header = []
        headers.map((item, index) => {
            _header.push(
                {
                    id: `${item.id}`,
                    label: <SettingLoanTypeTableHeader
                        min={item.minT}
                        max={item.maxT}
                        id={item.id}
                        handleUpdateTable={handleUpdateTable}
                    />
                }
            )
        })

        return _header
    }

    function generateTableItems(rows) {
        const _rows = []

        rows.map((item, index) => {
            let row = {}

            item.cells.map((cell, cellIndex) => {
                row[cell.headerId] = cell.loanKindCodeNames
            })
            _rows.push(row)
        })

        return _rows
    }

    function handleUpdateTable() {
        getDataFromServer()
    }

    return (
        <RaikoBaseCardContainer>
            <RaikoGridOneColumn>
                <RaikoSectionContainer
                    title={"حدود جدول نوع وام"}
                    subTitle={"برای بروزرسانی حدود بر روی عنوان هر ستون کلیک نمایید."}
                >
                    <RaikoGridOneColumn className={css`gap: 1.5rem`}>
                        {
                            loadingShimmerState ?
                                [...Array(3)].map((item, index) => {
                                    return <Skeleton
                                        variant={"rounded"}
                                        className={css`
                                          padding: 100px;
                                          border-radius: 15px !important`}
                                    />
                                }) :
                                loanKindTables.map((item, index) => {
                                    return <RaikoGridOneColumn>
                                        <RaikoTableTitleContainer title={item.title}/>
                                        <RaikoCustomTable
                                            header={item.header}
                                            data={item.items}
                                            isLoading={false}
                                        />
                                    </RaikoGridOneColumn>

                                })

                        }

                    </RaikoGridOneColumn>
                </RaikoSectionContainer>
            </RaikoGridOneColumn>
        </RaikoBaseCardContainer>
    )
}
